export default [
  {
    key: "4",
    name: { tw: "造訪流量 ", en: "Sessions" },
    result: "分析中",
    status: "尚未檢核",
    type: "checkSessions",
    value: false,
    description:
      "工作階段代表訪客在網站上的一次連續互動，工作階段數可視為造訪次數，是衡量網站流量的重要指標。",
    descriptionLink:
      "https://support.google.com/analytics/answer/9191807?hl=zh-Hant",
  },
  {
    key: "3",
    name: { tw: "客戶有效互動率", en: "Engagement Rate" },
    result: "分析中",
    status: "尚未檢核",
    type: "checkEngagementRate",
    value: [],
    description:
      "應用程式於前景運作或用戶與網頁互動的時間長度，可衡量用戶停留與互動的意願。",
    descriptionLink:
      "https://support.google.com/analytics/answer/12195621?hl=zh-Hant",
  },
  {
    key: "2",
    name: { tw: "加入購物車率", en: "Add To Cart Rate" },
    result: "分析中",
    status: "尚未檢核",
    type: "checkAddToCartRate",
    value: [],
    description:
      "加入購物車的次數佔整體工作階段（造訪次數）的比例，可衡量訪客的購買意圖。若非購物型網站，可忽略此指標。",
    descriptionLink: "",
  },
  {
    key: "1",
    name: { tw: "購買轉換率", en: "Purchase Conversion Rate" },
    result: "分析中",
    status: "尚未檢核",
    type: "checkConversionRate",
    value: "",
    description:
      "完成購買的次數佔整體工作階段（造訪次數）的比例，可衡量網站流量的轉換品質。若非購物型網站，可忽略此指標。",
    descriptionLink: "",
  },
];
